import {apsEnums} from "../../shared/dto/aps.enums";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsCommands} from "../../shared/dto/aps.commands";
import * as _ from "lodash";
import {List}  from "lodash";

export class AlertRoleMappingModel implements apsViewModels.AlertRoleMapping {
  constructor(alertRole: apsViewModels.AlertRoleMapping = null) {
    if (alertRole){
      this.roleId = alertRole.roleId;
      this.roleName = alertRole.roleName;

      this.plants = _.map(alertRole.plants, (plant) => {
        return _.assign(plant, new AlertRolePlant(plant));
      });
    }
  }

  roleId: string;
  roleName: string;
  plants: Array<apsViewModels.AlertRolePlant>;
}

export class AlertRolePlant implements apsViewModels.AlertRolePlant {
  constructor(plant: any) {
    if (plant) {
      this.alertRoleMappingId = plant.alertRoleMappingId;
      this.plantId = plant.plantId;
      this.plantName = plant.plantName,
      this.active = plant.active;
    }
  }

  alertRoleMappingId: string;
  plantId: string;
  plantName: string;
  active: boolean;
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/models/alerts/alertRoleModels.ts